// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".google-placement-selector .placement-selector {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n}\n", "",{"version":3,"sources":["GooglePreview.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;AACR","file":"GooglePreview.css","sourcesContent":[".google-placement-selector .placement-selector {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n}\n"]}]);
// Exports
module.exports = exports;
